import { render, staticRenderFns } from "./VipBuy.vue?vue&type=template&id=1b9ae374"
import script from "./VipBuy.vue?vue&type=script&lang=js"
export * from "./VipBuy.vue?vue&type=script&lang=js"
import style0 from "./VipBuy.vue?vue&type=style&index=0&id=1b9ae374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports